(() => {
  if(window.YogaSpacePurchaseNotifications)return;
  window.YogaSpacePurchaseNotifications=true;
  const origin='https://yogaspace.app';
  const local=['localhost','127.0.0.1'].includes(location.hostname);
  const endpoint=location.hostname==='yogaspace.app'||local?'/api/recent-purchases':origin+'/api/recent-purchases';
  const toast=document.createElement('aside');
  toast.className='purchase-notice';toast.hidden=true;toast.setAttribute('aria-label','Recent purchase');
  toast.innerHTML=`<img class="purchase-notice__thumbnail" src="${origin}/assets/app-gallery-settings-neutral-b648e6896c3918f5-2160.webp" alt="Yoga Space" width="44" height="44"><div class="purchase-notice__copy" role="status" aria-live="polite"><p><strong></strong> Just joined</p><div class="purchase-notice__meta"><span hidden style="display:none"></span><small class="purchase-notice__brand"><img src="${origin}/assets/yoga-space-app-icon-1c7ac0d5a79685bb.svg" alt="" width="14" height="14">Yoga Space</small></div></div><button class="purchase-notice__close" type="button" aria-label="Dismiss purchase notification"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m4 4 8 8M12 4l-8 8"/></svg></button>`;
  document.body.append(toast);
  let purchases=[],current=null,index=0,visible=false,exitTimer,nextTimer,pending=false;
  // Fixed rollout boundary; historical paid timestamps are never rewritten.
  const NEW_PURCHASES_FROM=1792084924;
  const isNew=p=>p.paidAt>=NEW_PURCHASES_FROM;
  const fresh=()=>purchases.filter(p=>Number.isInteger(p.paidAt)&&Date.now()/1000>=p.paidAt&&Date.now()/1000-p.paidAt<(isNew(p)?18000:172800)).sort((a,b)=>b.paidAt-a.paidAt);
  const age=p=>{const minutes=Math.floor((Date.now()/1000-p.paidAt)/60);return minutes<1?'Just now':minutes<60?`${minutes} ${minutes===1?'minute':'minutes'} ago`:`${Math.floor(minutes/60)} ${minutes<120?'hour':'hours'} ago`;};
  function updateAge(){const label=toast.querySelector('.purchase-notice__meta > span');label.hidden=!isNew(current);label.style.display=label.hidden?'none':'';label.textContent=isNew(current)?age(current):'';}
  const blocked=()=>document.hidden||document.querySelector('dialog[open],#ys-exit-reminder:not([hidden]),.ys-cookie-panel:not([hidden])');
  const follow=document.querySelector('.purchase-follow-widget');
  const end=Date.parse(document.querySelector('[data-ys-launch-offer]')?.dataset.endsAt);
  function position(){
    if(!follow)return;
    const remaining=end-Date.now();
    follow.toggleAttribute('data-final-day-hidden',!(remaining>0&&remaining<=86400000));
    const t=toast.getBoundingClientRect();
    let bottom=24;
    for(const obstacle of [follow,document.querySelector('.ys-cookie-settings:not([hidden])')]){
      if(!obstacle)continue;
      const r=obstacle.getBoundingClientRect();
      if(r.height>0&&r.bottom>0&&r.top<innerHeight&&getComputedStyle(obstacle).visibility!=='hidden'&&r.right>t.left&&r.left<t.right)bottom=Math.max(bottom,innerHeight-r.top+12);
    }
    toast.style.setProperty('--purchase-demo-bottom',`${bottom}px`);
  }
  function schedule(){clearTimeout(nextTimer);nextTimer=setTimeout(show,10000+Math.floor(Math.random()*35001));}
  function dismiss(){
    if(!visible)return;
    visible=false;current=null;clearTimeout(exitTimer);toast.classList.remove('is-visible');
    setTimeout(()=>{toast.hidden=true;schedule();},450);
  }
  function show(){
    const rows=fresh();
    if(visible)return;
    if(blocked()||!rows.length){schedule();return;}
    current=rows[index++%rows.length];
    toast.querySelector('strong').textContent=current.firstName;
    updateAge();
    toast.hidden=false;visible=true;position();
    requestAnimationFrame(()=>requestAnimationFrame(()=>{if(visible){toast.classList.add('is-visible');exitTimer=setTimeout(dismiss,10000);}}));
  }
  async function refresh(){
    if(pending)return;pending=true;
    try{
      const response=await fetch(endpoint,{cache:'no-store',credentials:'omit',signal:AbortSignal.timeout(20000)});
      if(!response.ok)throw Error();
      const data=await response.json();
      if(data.source!=='stripe'||!Array.isArray(data.purchases))throw Error();
      const previousNewest=fresh()[0]?.paidAt||0;
      purchases=data.purchases.slice(0,10).filter(p=>typeof p.firstName==='string'&&/^[\p{L}\p{M}][\p{L}\p{M}’'-]{0,39}$/u.test(p.firstName));
      if(fresh()[0]?.paidAt>previousNewest)index=0;
    }catch{purchases=[];}finally{pending=false;}
  }
  toast.querySelector('button').addEventListener('click',dismiss);
  toast.addEventListener('keydown',event=>{if(event.key==='Escape')dismiss();});
  window.addEventListener('resize',position,{passive:true});window.addEventListener('scroll',position,{passive:true});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
  setInterval(()=>{position();if(visible&&current){if(blocked()||!fresh().some(p=>p.firstName===current.firstName&&p.paidAt===current.paidAt))dismiss();else updateAge();}},1000);
  position();refresh();setInterval(refresh,60000);nextTimer=setTimeout(show,10000);
})();
